/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from "react";
import CSSModules from "react-css-modules";
import styles from "./styles.scss";

const defaultProps = {
  status: "idle",
  pullRight: false,
  more: false,
  mark: null,
};

class TablePagers extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { mark, more, status } = this.props;
    const hasPrev = mark > 0 ? true : false;

    let nextIcon = <i className="fa fa-chevron-circle-right" />;
    let prevIcon = <i className="fa fa-chevron-circle-left" />;

    if (status === "loading" || status === "request") {
      nextIcon = <i className="fa fa-spinner fa-spin" />;
      prevIcon = <i className="fa fa-spinner fa-spin" />;
    }
    if (!more) {
      nextIcon = <i className="fa fa-circle" />;
    }
    if (!hasPrev) {
      prevIcon = <i className="fa fa-circle" />;
    }

    return (
      <ul styleName="table-pager" className="list-inline">
        <li>
          <button
            styleName="pager-button"
            onClick={() => this.props.change(false)}
            disabled={!hasPrev}
          >
            {prevIcon}
          </button>
        </li>
        <li>
          <button
            styleName="pager-button"
            onClick={() => this.props.change(true)}
            disabled={!more}
          >
            {nextIcon}
          </button>
        </li>
      </ul>
    );
  }
}

TablePagers.defaultProps = defaultProps;

export default CSSModules(TablePagers, styles);




// WEBPACK FOOTER //
// ./src/components/TablePagers/index.jsx